import httpServices from './httpServices'

async function getGroupExpenses(groupId) {
    const response = await httpServices.get(`/expenses/group/${groupId}`)
    return response.data
}

async function createExpense({ groupId, title, amount, category, splitAmong, shares, rawMessage, paidCurrency, date, scanId }) {
    const response = await httpServices.post('/expenses', {
        // scanId (from a prior scanReceipt call) is how the server knows this
        // expense came from a receipt scan and counts it toward the monthly
        // plan limit — see services/usageService.js. Omit it and the scan is
        // free, by design: only a scan that actually became an expense counts.
        groupId, title, amount, category, splitAmong, shares, rawMessage, paidCurrency, date, scanId,
    })
    return response.data
}

async function updateExpense(expenseId, updates) {
    const response = await httpServices.put(`/expenses/${expenseId}`, updates)
    return response.data
}

async function deleteExpense(expenseId) {
    const response = await httpServices.delete(`/expenses/${expenseId}`)
    return response.data
}

async function scanReceipt(groupId, file) {
    const formData = new FormData();
    formData.append('receipt', file);
    const response = await httpServices.post(`/expenses/receipt/${groupId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
}

async function previewSplitwiseImport(file, flipDirection = false) {
    const formData = new FormData();
    formData.append('file', file);
    if (flipDirection) formData.append('flipDirection', 'true');
    const response = await httpServices.post('/expenses/import/preview', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
}

async function commitSplitwiseImport(payload) {
    const response = await httpServices.post('/expenses/import/commit', payload)
    return response.data
}

async function undoSplitwiseImport(batchId) {
    const response = await httpServices.delete(`/expenses/import/${batchId}`)
    return response.data
}

async function createSettlement({ groupId, recipient, amount }) {
    const response = await httpServices.post('/expenses/settlement', { groupId, recipient, amount })
    return response.data
}

// creditor records money received from a debtor (auto-approved)
async function markSettlementReceived({ groupId, payer, amount }) {
    const response = await httpServices.post('/expenses/settlement/received', { groupId, payer, amount })
    return response.data
}

async function updateSettlementStatus(settlementId, status) {
    const response = await httpServices.put(`/expenses/settlement/${settlementId}`, { status })
    return response.data
}

export default {
    getGroupExpenses,
    createExpense,
    updateExpense,
    deleteExpense,
    scanReceipt,
    previewSplitwiseImport,
    commitSplitwiseImport,
    undoSplitwiseImport,
    createSettlement,
    markSettlementReceived,
    updateSettlementStatus,
}
